<div class="dialog-container">
  <div class="dialog-icon-container">
    <span class="dialog-icon" [ngClass]="data.context === 'limit_reached' ? 'warning' : 'primary'">
      <mat-icon>{{ iconName }}</mat-icon>
    </span>
  </div>
  
  <h2 mat-dialog-title class="dialog-title">{{ title }}</h2>
  
  <mat-dialog-content class="dialog-content">
    <p class="message-text">{{ message }}</p>
    
    @if (data.planName) {
      <div class="plan-info">
        <span class="plan-label">{{ 'activateSubscriptionDialog.plan' | translate }}</span>
        <span class="plan-name">{{ data.planName }}</span>
      </div>
    }
    
    @if (error$ | async; as error) {
      <div class="error-message">
        <mat-icon>error_outline</mat-icon>
        <span>{{ error }}</span>
      </div>
    }
  </mat-dialog-content>
  
  <mat-dialog-actions class="dialog-actions" align="center">
    <button mat-stroked-button 
            class="cancel-button" 
            (click)="onCancel()"
            [disabled]="loading$ | async">
      {{ 'activateSubscriptionDialog.cancel' | translate }}
    </button>
    <button mat-flat-button 
            color="primary"
            class="activate-button" 
            (click)="onActivate()"
            [disabled]="loading$ | async">
      @if (loading$ | async) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        <span>{{ 'activateSubscriptionDialog.activate' | translate }}</span>
      }
    </button>
  </mat-dialog-actions>
</div>
